import React, { useEffect, cloneElement, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setQuestionViewAction } from "../../../../redux/answeringQuestions/questionView";
import useScribbleTooltip from "../../../../hooks/answeringQuestions/useScribbleTooltip";
import useAmplitude from "../../../../hooks/useAmplitude";

const QuestionTipHider = ( props ) => {

  const answeringQuestions = useSelector( state => state.answeringQuestions );
  const questionView = useSelector( state => state.questionView );

  const dispatch = useDispatch();
  const { setAmplitudeLog } = useAmplitude();
  const setQuestionView = payload => { dispatch( setQuestionViewAction( payload ) ) };

  const { hideScribbleTooltip } = useScribbleTooltip();

  useEffect( () => {
    if ( questionView.tooltipStatus ) {
      const fadeTooltip = () => {
        setQuestionView( { tooltipStatus : 2 } );
        timer = setTimeout( hideTooltip, 1000 );
      };
      const hideTooltip = () => {
        setQuestionView( { tooltipStatus : 0 } );
      };
      let timer = setTimeout( fadeTooltip, 4000 );
      return () => {
        clearTimeout( timer );
        hideTooltip();
      };
    }
  }, [] );

  useEffect( () => {
    answeringQuestions.data.qstCd && setQuestionView( { isShowTip : false } );
  }, [ answeringQuestions.data.qstCd ] );

  const showTip = ( event ) => {
    if (!questionView.isShowTip){
      setAmplitudeLog({
        eventName: {
          name: '보기조회 시작',
          event: {
            "학습유형": '',
            "소주제이름": answeringQuestions?.data?.stepNm,
            "소주제코드": answeringQuestions?.data?.stgCd,
            "문항코드": answeringQuestions?.data?.qstCd,
            "커리큘럼그룹": answeringQuestions?.data?.thmaNm,
            "커리큘럼명": answeringQuestions?.data?.stepNm,
          }
        }
      })
    } else {
      setAmplitudeLog({ eventCategory: 'learning', eventName: '보기조회 종료' });
    }

    setQuestionView( {
      isShowTip : ! questionView.isShowTip,
      tooltipStatus : 0
    } );


    hideScribbleTooltip();
    event.stopPropagation();
  };

  return cloneElement( props.children || <Fragment />, {
    onShow : showTip
  } );

};

export default QuestionTipHider;
